import React from "react";
import styles from "./ShoppingSearchResults.module.scss";
import { useCreation } from "ahooks";
import { ShoppingSearchResultsBloc } from "./ShoppingSearchResultsBloc";
import { RatingReviewsComponent } from "../components/RatingReviews/RatingReviewsComponent";
import { ShoppingProductItemView } from "../ShoppingProduct/ShoppingProduct";
import isBlank from "@sedan-utils/is-blank";
import { LoadMoreButton } from "../components/LoadMoreButton/LoadMoreButton";
import { Img } from "../ImgV2/Img";
import { map } from "lodash";
export function ShoppingSearchResults(props) {
  var bloc = useCreation(function () {
    return new ShoppingSearchResultsBloc(props);
  }, []);
  var state = bloc.state.value;
  var showDetail = !isBlank(state.detailProductItem);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showDetail && /*#__PURE__*/React.createElement(ShoppingProductItemView, {
    item: state.detailProductItem,
    showBackBtn: true,
    tapBackBtn: function tapBackBtn() {
      bloc.setShowDetail();
    }
  }), !showDetail && /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, props.result_title), /*#__PURE__*/React.createElement("div", {
    className: styles.scrollView
  }, map(state.list, function (item, index) {
    return /*#__PURE__*/React.createElement(ShoppingResultsItemView, {
      item: item,
      onClick: function onClick() {
        bloc.setShowDetail(item);
      },
      key: index
    });
  })), state.showLoadMore && /*#__PURE__*/React.createElement(LoadMoreButton, {
    btnText: "See more",
    loadMore: function loadMore() {
      return bloc.loadMore();
    }
  })));
}
function ShoppingResultsItemView(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.shoppingItem,
    onClick: function onClick() {
      return props.onClick();
    }
  }, /*#__PURE__*/React.createElement(Img, {
    imgKey: props.item.product_image,
    className: "shoppingResultsIconImg"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.itemTitle
  }, props.item.product_name), /*#__PURE__*/React.createElement("div", {
    className: styles.price
  }, "".concat(props.item.product_price)), /*#__PURE__*/React.createElement(RatingReviewsComponent, {
    rating: " ".concat(props.item.product_rating, " "),
    reviews: "(".concat(props.item.product_reviews, " reviews)")
  })));
}